/** Spielinhalte als Daten. Keine Spiellogik; Formeln hier lesen nur Zustand. */

export const IND:any=[
 {id:'leben',n:'Lebenserwartung',u:' Jahre',d:1,up:true,a:.02,iss:['gkv','pflege','aerzte']},
 {id:'warte',n:'Wartezeit auf Facharzttermin',u:' Tage',d:0,up:false,a:.08,iss:['aerzte','gkv']},
 {id:'pisa',n:'Bildungsniveau (PISA)',u:' Punkte',d:0,up:true,a:.025,iss:['bildung','kinderarmut']},
 {id:'wohn',n:'Fehlende Wohnungen',u:' Tsd.',d:0,up:false,a:.04,iss:['wohnen']},
 {id:'insol',n:'Firmeninsolvenzen',u:' /Jahr',d:0,up:false,a:.1,iss:['insolvenz','energie']},
 {id:'gruend',n:'Unternehmensgründungen',u:' Tsd./Jahr',d:0,up:true,a:.06,iss:['insolvenz','digital']},
 {id:'co2',n:'CO₂-Ausstoß',u:' Mio. t',d:0,up:false,a:.05,iss:['klima']},
 {id:'krimi',n:'Straftaten je 100.000 Einw.',u:'',d:0,up:false,a:.06,iss:['sicher']},
 {id:'armut',n:'Armutsquote',u:' %',d:1,up:false,a:.05,iss:['kinderarmut','preise']},
 {id:'bahn',n:'Pünktlichkeit Fernverkehr',u:' %',d:0,up:true,a:.05,iss:['infra']},
 {id:'strom',n:'Strompreis Haushalte',u:' ct/kWh',d:1,up:false,a:.1,iss:['energie']},
 {id:'fachl',n:'Fachkräftelücke',u:' Tsd.',d:0,up:false,a:.06,iss:['fach']},
 {id:'vertr',n:'Vertrauen in die Demokratie',u:' %',d:0,up:true,a:.1,iss:['laendlich']},
];
export const INDM=Object.fromEntries(IND.map((x:any)=>[x.id,x]));
export const ISS2IND:Record<string,string>={};
IND.forEach((x:any)=>x.iss.forEach((i:string)=>{if(!ISS2IND[i])ISS2IND[i]=x.id}));
